namespace Nobox.Pages {
    export namespace InboxUploadFileServiceService {
        export const baseUrl = '~/Inbox/UploadFile';

        export declare function ConvertBase64ToFile(request: Base64ToFileRequest, onSuccess?: (response: InboxResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function UploadBase64(request: Web.Hubs.MessageMedia, onSuccess?: (response: InboxResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function UploadContactFile(request: Serenity.UploadedFile, onSuccess?: (response: InboxResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function UploadFile(request: Serenity.ServiceRequest, onSuccess?: (response: InboxResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            ConvertBase64ToFile = "~/Inbox/UploadFile/ConvertBase64ToFile",
            UploadBase64 = "~/Inbox/UploadFile/UploadBase64",
            UploadContactFile = "~/Inbox/UploadFile/UploadContactFile",
            UploadFile = "~/Inbox/UploadFile/UploadFile"
        }

        [
            'ConvertBase64ToFile', 
            'UploadBase64', 
            'UploadContactFile', 
            'UploadFile'
        ].forEach(x => {
            (<any>InboxUploadFileServiceService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
